import type { SurveyElementJson } from '@coorum-research/shared-common/types/survey-json.type'
import { use, useMemo } from 'react'
import { surveyLogic } from '../survey/survey-logic'
import { ThemeContext } from './ThemeContext'

/**
 * SurveyComponentFlow(アンケートページ)の進捗バー
 */
export function SurveyComponentFlowProgress({ currentPageIndex, allElements }: {
  currentPageIndex: number
  allElements: SurveyElementJson[]
}) {
  const theme = use(ThemeContext)
  const { getProgressiveWidth } = surveyLogic()

  const themeStyle = useMemo(() => ({
    backgroundColor: theme.mainColor,
    color: theme.mainTextColor,
  }), [theme])

  const width = useMemo(() => getProgressiveWidth(allElements, currentPageIndex), [allElements, currentPageIndex])

  return (
    <div className="p-6">
      <div className="overflow-hidden rounded-full bg-gray-200">
        <div style={{ ...themeStyle, width }} className="h-2 rounded-full" />
      </div>
    </div>
  )
}
